import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-submitted-emojis-preview',
  templateUrl: './submitted-emojis-preview.component.html',
  styleUrls: ['./submitted-emojis-preview.component.scss']
})
export class SubmittedEmojisPreviewComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() color1: string;
  @Input() color2: string;
  @Input() s3BucketUrl: string;
  @Input() menuArt: string;
  @Input() drawDate: any;
  @Input() gameEmojis: any[] = []; // The 48 game emojis

  emojis: string[] = [];

  constructor() { }

  ngOnInit() {
    this.processEmojis();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gameEmojis) {
      this.processEmojis();
    }
  }

  private processEmojis() {
    // Take the first 6 emojis from the game's 48 emojis
    if (this.gameEmojis && this.gameEmojis.length > 0) {
      this.emojis = this.gameEmojis
        .slice(0, 6)
        .map(emojiObj => {
          // Handle the nested emoji object structure
          // The emoji image is at emojiObj.emoji.image
          if (emojiObj && emojiObj.emoji && emojiObj.emoji.image) {
            const imagePath = emojiObj.emoji.image;
            return imagePath.startsWith('http') ? imagePath : `${this.s3BucketUrl}${imagePath}`;
          }
          // Fallback for direct string or simple object
          if (typeof emojiObj === 'string') {
            return emojiObj.startsWith('http') ? emojiObj : `${this.s3BucketUrl}${emojiObj}`;
          } else if (emojiObj && emojiObj.image) {
            return emojiObj.image.startsWith('http') ? emojiObj.image : `${this.s3BucketUrl}${emojiObj.image}`;
          }
          return '';
        })
        .filter(url => url !== '');
    } else {
      this.emojis = [];
    }
  }
}
